export default __webpack_public_path__ + "static/media/welcome.76d09e5d.png";